import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'modal-info-row',
  templateUrl: 'modal-info-row.component.html',
  styleUrls: ['modal-info-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalInfoRowComponent {
  @Input() strongText: string;
  @Input() regText: string;
}
